import { useUpdateFileReference } from './useUpdateFileReference';
import { getUpdateObjFromUpload } from '../data/getUpdateObjFromUpload';
import { UpdateFileRefPayload, FileUploadSuccess } from '@usacsmideo/types';
import { notifyChartSaveError } from '../utilities/chartSaveError';
import React from 'react';

export const useHandleFileUploadSuccess = () => {
  const { mutateAsync } = useUpdateFileReference();
  const updateFirestore = React.useCallback(
    (payload: FileUploadSuccess) => {
      const docToUpdate = payload.docToUpdate;
      const data = getUpdateObjFromUpload(payload.type, payload.url);
      const updateBody = {
        [docToUpdate]: {
          patientId: payload.patientId || ' ',
          docData: data,
        },
      } as UpdateFileRefPayload;
      // A PROMISE, NOT A PER-CALL onError: CALLERS SUCH AS PhotoCamera2 UNMOUNT ONCE THE UPLOAD IS DONE,
      // AND TANSTACK DROPS PER-CALL CALLBACKS FOR AN UNMOUNTED OBSERVER. useUpdateFileReference HAS
      // ALREADY REPORTED THE ERROR TO SENTRY; THIS TELLS THE PATIENT (CU-17tm466jq2e).
      mutateAsync(updateBody).catch(() => notifyChartSaveError());
    },
    [mutateAsync],
  );
  return { updateFirestore };
};
